import React from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import snooperTheme from '../../../theme/snooperTheme';
import AppBarContainer from './appBar/appBar';
import Intercom from '../components/intercom/intercomSnippet';
import { readEncodedUserFromLocalStorage } from '../../authentication/AuthProvider';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  },
  appFrame: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'auto',
    height: '100vh',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    background: '#f5f8fa',
    marginTop: '64px',
    height: 'calc(100% - 64px)',
  },
};

class MyLayout extends React.Component {
  render() {
    const { classes, children, logout } = this.props;
    const user = readEncodedUserFromLocalStorage();

    return (
      <MuiThemeProvider theme={snooperTheme}>
        <div className={classes.root}>
          <Intercom intercomId="elzqchc8" user={user} />

          <div className={classes.appFrame}>
            <AppBarContainer logout={logout} />
            <div className={classes.content}>{children}</div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

MyLayout.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  logout: PropTypes.shape(PropTypes.any).isRequired,
};
export default withStyles(styles)(MyLayout);
